import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  FormGroup,
  FormField,
  Form,
  Button,
  Input
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardDrugDispensingInterfaceUX = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        id="CardDrugDispensingInterfaceUX-div-0"
        style={{width: "calc(-180px + 100vw)", height:"100%",padding:"10px"}}>
        <div
          className="ui form"
          id="CardDrugDispensingInterfaceUX-div-1"
          style={{padding: "10px 5px 15px", marginBottom: "-10px"}}>
          
          <Form
            id="CardDrugDispensingInterfaceUX-Form-29">
            <FormGroup
              id="CardDrugDispensingInterfaceUX-FormGroup-30"
              inline={true}
              style={{ marginBottom: "0px"}}>
              <FormField
                id="CardDrugDispensingInterfaceUX-FormField-37"
                width={2}>
                <label
                  id="CardDrugDispensingInterfaceUX-label-45">
                  {props.languageUX === "en" ? "Creation Date" : "วันที่สร้าง"}
                </label>
              </FormField>
              <FormField
                id="CardDrugDispensingInterfaceUX-FormField-38"
                width={2}>
                <label
                  id="CardDrugDispensingInterfaceUX-label-46">
                  {props.languageUX === "en" ? "HN" : "HN"}
                </label>
              </FormField>
              <FormField
                id="CardDrugDispensingInterfaceUX-FormField-39"
                width={2}>
                <label
                  id="CardDrugDispensingInterfaceUX-label-44">
                  {props.languageUX === "en" ? "Product Code" : "รหัสสินค้า"}
                </label>
              </FormField>
              <FormField
                id="CardDrugDispensingInterfaceUX-FormField-40"
                width={2}>
                <label
                  id="CardDrugDispensingInterfaceUX-label-43">
                  {props.languageUX === "en" ? "Status" : "สถานะ"}
                </label>
              </FormField>
              <FormField
                id="CardDrugDispensingInterfaceUX-FormField-41"
                width={2}>
                <label
                  id="CardDrugDispensingInterfaceUX-label-42">
                  {"\u00A0"}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardDrugDispensingInterfaceUX-FormGroup-31"
              inline={true}>
              <FormField
                id="CardDrugDispensingInterfaceUX-FormField-32"
                width={2}>
                <div
                  id="CardDrugDispensingInterfaceUX-div-51"
                  style={{ width: "100%" }}>
                  
                  <DateTextBox
                    id="CardDrugDispensingInterfaceUX-DateTextBox-56"
                    onChange={props.onChangeDate}
                    value={props.searchDrugDispensing?.createdDate}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                id="CardDrugDispensingInterfaceUX-FormField-33"
                width={2}>
                <div
                  id="CardDrugDispensingInterfaceUX-div-50"
                  style={{ width: "100%" }}>
                  
                  <Input
                    id="CardDrugDispensingInterfaceUX-Input-59"
                    name="hn"
                    onChange={props.onChangeData}
                    value={props.searchDrugDispensing?.hn || ""}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardDrugDispensingInterfaceUX-FormField-34"
                width={2}>
                <div
                  id="CardDrugDispensingInterfaceUX-div-49"
                  style={{ width: "100%" }}>
                  
                  <Input
                    id="CardDrugDispensingInterfaceUX-Input-58"
                    name="productCode"
                    onChange={props.onChangeData}
                    value={props.searchDrugDispensing?.productCode || ""}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardDrugDispensingInterfaceUX-FormField-35"
                width={2}>
                <div
                  id="CardDrugDispensingInterfaceUX-div-48"
                  style={{ width: "100%" }}>
                  
                  <Input
                    id="CardDrugDispensingInterfaceUX-Input-57"
                    name="status"
                    onChange={props.onChangeData}
                    value={props.searchDrugDispensing?.status || ""}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardDrugDispensingInterfaceUX-FormField-36"
                width={2}>
                <div
                  id="CardDrugDispensingInterfaceUX-div-47"
                  style={{ width: "100%", display: "flex" }}>
                  
                  <div
                    id="CardDrugDispensingInterfaceUX-div-52"
                    style={{ margin: "0px 20px" }}>
                    
                    <div
                      id="CardDrugDispensingInterfaceUX-div-54">
                      {props.searchButton}
                    </div>
                  </div>
                  <div
                    id="CardDrugDispensingInterfaceUX-div-53">
                    
                    <Button
                      color="orange"
                      id="CardDrugDispensingInterfaceUX-Button-55"
                      onClick={props.onClearFilter}>
                      {props.languageUX === "en" ? "Clear" : "ล้างหน้าจอ"}
                    </Button>
                  </div>
                </div>
              </FormField>
            </FormGroup>
          </Form>
        </div>
        <div
          id="CardDrugDispensingInterfaceUX-div-2">
          
          <Table
            className="--rt-tbody-overflow-y-hidden"
            columns={props.tableHeaders}
            data={props.drugDispensingInterfaceList}
            id="CardDrugDispensingInterfaceUX-Table-4"
            minRows="5"
            onPageChange={props.onPageChange}
            onPageSizeChange={props.onPageSizeChange}
            page={props.paginatedItems?.page || 0}
            pageSize={props.paginatedItems?.pageSize || 0}
            pages={Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)}
            style={{ height: "calc(95vh - 14.5rem)"}}>
          </Table>
        </div>
        <div
          className="ui form"
          id="CardDrugDispensingInterfaceUX-div-3"
          style={{ marginTop: "20px" }}>
          
          <FormGroup
            id="CardDrugDispensingInterfaceUX-FormGroup-6"
            inline={true}
            style={{ justifyContent: "flex-end" }}>
            <FormField
              id="CardDrugDispensingInterfaceUX-FormField-7"
              inline={true}>
              <div
                id="CardDrugDispensingInterfaceUX-div-9">
                {props.addButton}
              </div>
            </FormField>
            <FormField
              id="CardDrugDispensingInterfaceUX-FormField-8"
              inline={true}>
              <div
                id="CardDrugDispensingInterfaceUX-div-10">
                {props.editButton}
              </div>
            </FormField>
          </FormGroup>
        </div>
      </div>
    )
}


export default CardDrugDispensingInterfaceUX

export const screenPropsDefault = {}

/* Date Time : Wed Oct 01 2025 12:45:55 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width: \"calc(-180px + 100vw)\", height:\"100%\",padding:\"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px 5px 15px\", marginBottom: \"-10px\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-div-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{ marginTop: \"20px\" }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 4,
      "name": "Table",
      "parent": 2,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "columns": {
          "type": "code",
          "value": "props.tableHeaders"
        },
        "data": {
          "type": "code",
          "value": "props.drugDispensingInterfaceList"
        },
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-Table-4"
        },
        "minRows": {
          "type": "value",
          "value": "5"
        },
        "onPageChange": {
          "type": "code",
          "value": "props.onPageChange"
        },
        "onPageSizeChange": {
          "type": "code",
          "value": "props.onPageSizeChange"
        },
        "page": {
          "type": "code",
          "value": "props.paginatedItems?.page || 0"
        },
        "pageSize": {
          "type": "code",
          "value": "props.paginatedItems?.pageSize || 0"
        },
        "pages": {
          "type": "code",
          "value": "Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"calc(95vh - 14.5rem)\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-FormGroup-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ justifyContent: \"flex-end\" }"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-FormField-7"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-FormField-8"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "props.addButton"
        },
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-div-9"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "props.editButton"
        },
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-div-10"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "Form",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-Form-29"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "FormGroup",
      "parent": 29,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-FormGroup-30"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ marginBottom: \"0px\"}"
        },
        "widths": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "FormGroup",
      "parent": 29,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-FormGroup-31"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "widths": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "FormField",
      "parent": 31,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-FormField-32"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "FormField",
      "parent": 31,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-FormField-33"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "FormField",
      "parent": 31,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-FormField-34"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "FormField",
      "parent": 31,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-FormField-35"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "FormField",
      "parent": 31,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-FormField-36"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "FormField",
      "parent": 30,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-FormField-37"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "FormField",
      "parent": 30,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-FormField-38"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "FormField",
      "parent": 30,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-FormField-39"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "FormField",
      "parent": 30,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-FormField-40"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "FormField",
      "parent": 30,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-FormField-41"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "label",
      "parent": 41,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00A0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-label-42"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "label",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะ",
          "valueEN": "Status"
        },
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-label-43"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "label",
      "parent": 39,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสสินค้า",
          "valueEN": "Product Code"
        },
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-label-44"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "label",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่สร้าง",
          "valueEN": "Creation Date"
        },
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-label-45"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "label",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": "HN",
          "valueEN": "HN"
        },
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-label-46"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "div",
      "parent": 36,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-div-47"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", display: \"flex\" }"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "div",
      "parent": 35,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-div-48"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "div",
      "parent": 34,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-div-49"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "div",
      "parent": 33,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-div-50"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "div",
      "parent": 32,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-div-51"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "div",
      "parent": 47,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-div-52"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 20px\" }"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "div",
      "parent": 47,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-div-53"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "div",
      "parent": 52,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchButton"
        },
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-div-54"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "Button",
      "parent": 53,
      "props": {
        "children": {
          "type": "value",
          "value": "ล้างหน้าจอ",
          "valueEN": "Clear"
        },
        "color": {
          "type": "value",
          "value": "orange"
        },
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-Button-55"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClearFilter"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 56,
      "name": "DateTextBox",
      "parent": 51,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-DateTextBox-56"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDate"
        },
        "value": {
          "type": "code",
          "value": "props.searchDrugDispensing?.createdDate"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "Input",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-Input-57"
        },
        "name": {
          "type": "value",
          "value": "status"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchDrugDispensing?.status || \"\""
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "Input",
      "parent": 49,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-Input-58"
        },
        "name": {
          "type": "value",
          "value": "productCode"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchDrugDispensing?.productCode || \"\""
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "Input",
      "parent": 50,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugDispensingInterfaceUX-Input-59"
        },
        "name": {
          "type": "value",
          "value": "hn"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchDrugDispensing?.hn || \"\""
        }
      },
      "seq": 59,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": true,
  "name": "CardDrugDispensingInterfaceUX",
  "project": "CLM CU",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
